import { FileText } from "lucide-react";

export default function LoanDocuments({
  badge,
  title,
  description,
  groups = [],
}) {
  return (
    <section id="documents" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          {badge && (
            <span className="text-primary font-semibold uppercase tracking-wider">
              {badge}
            </span>
          )}

          <h2 className="mt-3 text-3xl md:text-4xl font-bold">{title}</h2>

          <p className="mt-6 text-lg text-slate-600 leading-8">{description}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mt-16">
          {groups.map((group) => {
            const Icon = group.icon;

            return (
              <div
                key={group.title}
                className="rounded-2xl border border-slate-200 bg-white p-8"
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                    <Icon className="w-6 h-6" />
                  </div>

                  <h3 className="text-xl font-semibold">{group.title}</h3>
                </div>

                <ul className="mt-6 space-y-3">
                  {group.documents.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <FileText className="w-5 h-5 text-primary mt-0.5 shrink-0" />

                      <span className="text-slate-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
